import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Update_record extends PureComponent {
  render() {
    return (
      <div className="row" id="update_record">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Update Record</h2>
              <p>
                The Update Record function is an efficient way to update
                specified fields in your record. If you wish to remove a
                property, you can update it with the value <strong>null</strong>
                .
              </p>
              <p>
                The Update Record function supports bulk record updates as well
                as individual record updates. All bulk functions in Nexoid are
                limited to 50 records per request.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Update Record Example</h2>
            </section>
            <section>
              <h3>Example 1: Single Record</h3>
              <p>
                This example will update the record with the Record ID of 454.
                "text_name" will become "Meet Greg Smith" and "long_room_no"
                will be removed.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePATCH">PATCH</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonP">454</span>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Greg Smith"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"long_room_no"</span>: null
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"453"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Greg Smith"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"object_created_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:04:16.069Z"</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"object_updated_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-08T13:42:10.852Z"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Multiple Records</h3>
              <p>This example will update 3 records.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePATCH">PATCH</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/bulk
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"records"</span>: [
                </div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"453"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"long_room_no"</span>:{" "}
                  <span className="jsonP">9</span>
                </div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;,</div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"454"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"Meet Matt Smith"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"long_room_no"</span>:{" "}
                  <span className="jsonP">3</span>
                </div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;,</div>
                <div className="i2">&#123;</div>
                <div className="i3">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"455"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"long_room_no"</span>: null
                </div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;</div>
                <div className="i1">]</div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"updated"</span>: [
                  <span className="jsonY">"453"</span>,{" "}
                  <span className="jsonY">"454"</span>,{" "}
                  <span className="jsonY">"455"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"failed"</span>: []
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Update_record;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Update_record.js